import {
  ActionButton,
  CarouselWrapper,
  ContactText,
  ContactWrapper,
  Inner,
  InnerSecond,
  IntroductionTitle,
  IntroductionWrapper,
  Jobs,
  JobsIntroduction,
  PlayVideoButton,
  PlayVideoContainer,
  PrimaryColor,
  TeamImagesItem,
  TeamImagesWrapper,
  TeamImageWrapper,
  Title,
  Wrapper,
} from './jobOpenings.styles';
import { RichText } from 'prismic-reactjs';
import { jobOpeningsHtmlSerializer } from '../../../utils/htmlSerializers/jobOpeningsHtmlSerializer';
import { IJobOpenings, IJobSummary } from './interfaces';
import { imageSerializer } from 'utils/imageSerializer';
import Image from 'next/image';
import { PlayIcon } from 'components/images/PlayImages/PlayImages';
import { JobItem } from './JobItem/JobItem';
import Carousel from '../../core/Carousel';
import { useMeetingVideo } from '../Integration/useMeetingVideo';
import { Integration } from '../Integration/Integration';

export const JobOpenings = ({
  description,
  items,
  title,
  titleAs,
  noJobsOffers,
  noJobsOffersEmail,
  stickerActionLink,
  playVideoText,
  joinText,
  joinTextPrimary,
  sendCvText,
  sendCvButton,
  teamImage,
  teamImages,
  teamImagesMobile,
}: IJobOpenings) => {
  const { handlePlayVideo, isFullscreen, handleClose, videoRef } =
    useMeetingVideo();
  return (
    <Wrapper>
      <Inner>
        <IntroductionWrapper>
          <div>
            <IntroductionTitle>
              <PrimaryColor>{joinTextPrimary} </PrimaryColor>
              {joinText}
            </IntroductionTitle>
            <PlayVideoContainer>
              <PlayVideoButton onClick={handlePlayVideo}>
                {playVideoText} <PlayIcon />
              </PlayVideoButton>
            </PlayVideoContainer>

            <Integration
              ref={videoRef}
              isFullscreen={isFullscreen}
              handleClose={handleClose}
            />
          </div>
          <JobsIntroduction>
            <RichText
              render={description}
              htmlSerializer={jobOpeningsHtmlSerializer}
            />
          </JobsIntroduction>
        </IntroductionWrapper>
      </Inner>

      <CarouselWrapper>
        <Carousel images={teamImagesMobile} />
      </CarouselWrapper>

      <TeamImageWrapper>
        <Image {...imageSerializer(teamImage)} />
      </TeamImageWrapper>

      <TeamImagesWrapper>
        {teamImages.map((el, index) => {
          return (
            <TeamImagesItem key={index}>
              <Image {...imageSerializer(el.team_images_item)} />
            </TeamImagesItem>
          );
        })}
      </TeamImagesWrapper>

      <InnerSecond>
        {items && items.length ? (
          <>
            <Title as={titleAs}>{title}</Title>
            <Jobs>
              {items.map((job: IJobSummary, index) => {
                return <JobItem key={index} {...job} />;
              })}
            </Jobs>
          </>
        ) : (
          <p>
            {noJobsOffers}
            <a href={stickerActionLink}>{noJobsOffersEmail}</a>
          </p>
        )}

        <ContactWrapper>
          <ContactText>{sendCvText}</ContactText>
          <ActionButton href={stickerActionLink}>{sendCvButton}</ActionButton>
        </ContactWrapper>
      </InnerSecond>
    </Wrapper>
  );
};
